import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { WorkplaceService } from '../../../../../services/workplace.service';
import { WorkplaceResponsiblePersonGridObject } from '@it2go/types';

interface State {
    workplaceResponsiblePersons: WorkplaceResponsiblePersonGridObject | null;
}

const defaultState: State = {
    workplaceResponsiblePersons: null,
};

@Injectable()
export class WorkplaceDetailResponsiblePersonsStore extends ComponentStoreFactory<State, WorkplaceService> {

    constructor() {
        super(defaultState, inject(Store), inject(WorkplaceService));
    }

}
